// eslint-disable-next-line no-shadow
enum SessionEventType {
    SESSION_START = 'SESSION_START',
    SESSION_END = 'SESSION_END',
    SESSION_FORCE_END = 'SESSION_FORCE_END',

    TASK_START = 'TASK_START',
    TASK_END = 'TASK_END',

    STEP_START = 'STEP_START',
    STEP_END = 'STEP_END',
    CALC_SAVED = 'CALC_SAVED',
    CALC_DELETED = 'CALC_DELETED',
    CALC_RESETED = 'CALC_RESETED',
    CALC_INCOMPLETED = 'CALC_INCOMPLETED',
    RES_SENT = 'RES_SENT',
    RES_DELETED = 'RES_DELETED',
    RES_SELECTED = 'RES_SELECTED',
    RES_MOVED = 'RES_MOVED',
    RES_INPUT = 'RES_INPUT',
    RECORD_START = 'RECORD_START',
    RECORD_END = 'RECORD_END',
    WARNING_TRIGGERED = 'WARNING_TRIGGERED',
    PLAYING_SOUND = 'PLAYING_SOUND',
    CLICK = 'CLICK',
    INPUT = 'INPUT',

    FULLSCREEN_IN = 'FULLSCREEN_IN',
    FULLSCREEN_OUT = 'FULLSCREEN_OUT',
    FOCUS_IN = 'FOCUS_IN',
    FOCUS_OUT = 'FOCUS_OUT',
    PAGE_REFRESH = 'PAGE_REFRESH',
}

export default SessionEventType;
